import client from '@/api/loginAPI.js';
import i18n from '@/i18n';

import { ErrorService } from '@/services/error-service.js';

const state = {
  form: {
    first_name: null,
    last_name: null,
    email: null,
    phone_number: null,
    comments: null,
    username: null,
    password1: null,
    password2: null
  },
  organisationToCreate: null,
  organisationThumbnail: null,
  organisationSpheres: [],
  signed: false,
  error: null,
  organisationSigned: false,
};

const getters = {
  getForm: state => state.form,
  getSigned: state => state.signed,
  getError: state => state.error,
};

const actions = {
  POST_SIGNUP: async ({ state, commit, dispatch }) => {
    try {
      let createdUsergroup;
      if (state.organisationToCreate) {
        createdUsergroup = await dispatch(
          'usergroups/CREATE_USERGROUP',
          {
            form: state.organisationToCreate,
            thumbnail: state.organisationThumbnail,
            spheres: state.organisationSpheres
          },
          { root: true }
        );
      }
      if (createdUsergroup) {
        state.form.usergroup_id = createdUsergroup.id;
      }
      const resp = await client.signUp(state.form);
      if (resp) {
        commit('SET_ERROR', undefined);
        commit('SET_SIGNED', true);
        commit('SET_ORGANISATION_SIGNED', true);
      }
    } catch (error) {
      commit(
        'SET_ERROR',
        error.response
        || i18n.t('messages.error'),
      );
      commit('SET_SIGNED', false);
      commit('SET_ORGANISATION_SIGNED', false);
    }
  },
};

const mutations = {
  SET_FORM: (state, data) => {
    state.form = data.form;
    state.organisationToCreate = data.organisationToCreate;
    state.organisationThumbnail = data.thumbnail;
    state.organisationSpheres = data.spheres;
  },
  SET_SIGNED: (state, value) => {
    if (value === true) {
      state.signed = true;
    } else {
      state.signed = false;
    }
  },
  SET_ERROR: (state, value) => {
    ErrorService.onError(value);
    state.error = value && value.data ? value.data : value;
  },
  SET_ORGANISATION_SIGNED: (state, value) => {
    state.organisationSigned = value === true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
